import $ from 'jquery';

function calculatePrice() {
  let total_price = 0;
  $('.order-plans input:checked').each(function () {
    const $this = $(this);
    const plan_price = parseInt($this.closest('tr').data('price'), 10);
    const plan_discount = parseInt(
      $this.closest('tr').find('select').val() as string,
      10
    );
    if (plan_price !== 0) {
      total_price += plan_price * ((100 - plan_discount) / 100);
    }
  });
  $('#total-price').text(` ${total_price},00 kr`);
}

function companyForm() {
  $('form#company-form')
    .on('keyup', 'input', function () {
      if ($('#company-info:checked').length) {
        $('#user_invoice_company').val($('#user_company').val());
        $('#user_invoice_email').val($('#user_email').val());
        $('#user_invoice_address').val($('#user_address').val());
        $('#user_invoice_zip').val($('#user_zip').val());
        $('#user_invoice_city').val($('#user_city').val());
        $('#user_invoice_orgnr').val($('#user_orgnr').val());
      }
    })
    .on('click', '.order-plans input', function () {
      calculatePrice();
    })
    .on('change', '.order-plans select', function () {
      calculatePrice();
    });
}

document.addEventListener('turbolinks:load', companyForm);
document.addEventListener('ajax:success', companyForm);
